import {LayoutMethod} from 'hooks/useComponentPosition/types';
import {ReactNode} from 'react';

export type Position = {
    height: number;
    left: number;
    top: number;
    width: number;
};

export type TooltipType = 'default' | 'info';

export const TOOLTIPTYPE: Record<TooltipType, string> = {
    default: 'tooltip',
    info: 'infotip',
};

export type Layout = 'bottom' | 'left' | 'right' | 'top';

export type TooltipWrapperProps = {
    children?: ReactNode;
    href?: string;
    layoutMethod?: LayoutMethod;
    message?: ReactNode | string;
    tooltipType?: TooltipType;
};
